export const FETCHING_LINEINFORMATION = 'FETCHING_LINEINFORMATION';
export const FETCH_LINEINFORMATION_SUCCESS = 'FETCHING_LINEINFORMATION_SUCCESS';


// WEBPACK FOOTER //
// ./src/redux/lineDataInformation/LineDataInformationConstants.js